import { createApiRequest } from "../common";
import { CreateOrgInviteRequestContent, CreateOrgInviteResponseContent } from '@equaliq/api-model';

export const createOrgInviteApi = async (request: CreateOrgInviteRequestContent): Promise<CreateOrgInviteResponseContent> => {
  const apiRequest = createApiRequest<CreateOrgInviteResponseContent>('post', '/orgs/invites/create');
  return apiRequest(request);
};
